import { render, staticRenderFns } from "./PerformancesAcademics.vue?vue&type=template&id=727f8efc"
import script from "./PerformancesAcademics.vue?vue&type=script&lang=js"
export * from "./PerformancesAcademics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports